var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu",style:(_vm.positionClass)},[_c('ul',_vm._l((_vm.menuItems),function(item,index){return _c('li',{key:index,on:{"click":function($event){$event.stopPropagation();_vm.onMenuClick(
          (function () {
            return item.label ? item.label : item;
          })()
        )}}},[(item.label)?_c('span',[_vm._v(_vm._s(item.label))]):_c('span',[_vm._v(_vm._s(item))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }